export const timeStamp = function (time, format, returnAsDate = false) {
    if (!time) {
        return returnAsDate ? null : "";
    }
    var date = new Date(time);
    if (returnAsDate) {
        return date; // 返回 Date 对象
    }

    if (!format) {
        format = "yyyy-MM-dd HH:mm:ss";
    }

    var Y = date.getFullYear();
    var M = date.getMonth() + 1;
    var D = date.getDate();
    var h = date.getHours();
    var m = date.getMinutes();
    var s = date.getSeconds();

    M = M < 10 ? "0" + M : M;
    D = D < 10 ? "0" + D : D;
    h = h < 10 ? "0" + h : h;
    m = m < 10 ? "0" + m : m;
    s = s < 10 ? "0" + s : s;

    return format
        .replace("yyyy", Y)
        .replace("MM", M)
        .replace("dd", D)
        .replace("HH", h)
        .replace("mm", m)
        .replace("ss", s);
}

export const timeLength = function (time) {
    if (!time) {
        return "";
    }
    time = new Date(time).getTime();
    var nowDate = new Date().getTime();
    var length = nowDate - time;
    var days = Math.floor(length / (24 * 3600 * 1000));
    if (days > 90) {
        return "超过三个月";
    }
    if (days > 60) {
        return "两个月前";
    }
    if (days > 30) {
        return "一个月前";
    }
    if (days > 0) {
        return days + "天前";
    }
    var leave1 = length % (24 * 3600 * 1000);
    var hours = Math.floor(leave1 / (3600 * 1000));
    if (hours > 0) {
        return hours + "小时前";
    }
    var leave2 = leave1 % (3600 * 1000);
    var minutes = Math.floor(leave2 / (60 * 1000));
    if (minutes > 0) {
        return minutes + "分钟前";
    }
    var leave3 = leave2 % (60 * 1000);
    var seconds = Math.round(leave3 / 1000);

    if (seconds > 0) {
        return seconds + "秒前";
    } else {
        return "刚刚";
    }
}
